var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-file-input',_vm._b({attrs:{"rules":_vm.rules,"name":"curriculum","label":"Currículum (.pdf, .doc ou .docx)","accept":".doc,.docx,.pdf"}},'v-file-input',_vm.fieldProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }